export default class Api {
    static getProject(idProject){
        let form = new FormData();
        let id_product = document.getElementById('product_page_product_id').value;
        form.append('id_project', idProject);
        form.append('id_product', id_product);
        return fetch(`/modules/new_creator/ajax/load_project_data.php`, {
            method: "POST",
            body: form
        });
    }

    static getMotivs(projectCode, interfacelanguage){
        let form = new FormData();
        form.append('project_code', projectCode);
        form.append('interfacelanguage', interfacelanguage);
        form.append('json', '1');
        return fetch(`/modules/new_creator/ajax/get_motivs.php`,{
            method: "POST",
            body: form
        });
    }

    static getProjectGroup(idProjectsGroups, tabId){
        let form = new FormData();
        form.append('id_projects_groups', idProjectsGroups);
        form.append('tab_id', tabId);
        form.append('interfacelanguage', 'pl');
        return fetch(`/modules/new_creator/ajax/get_projects_group.php`, {
            method: "POST",
            body: form
        })
    }

    static getFontGroup(fontGroup, callback){
        let form = new FormData();
        form.append('name_group', fontGroup);
        fetch(`/modules/new_creator/ajax/get_fonts.php`,{
            method: "POST",
            body: form
        }).then(data => data.json())
        .then((json) => {
            callback(json);
        });
    }
}